"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _times = _interopRequireDefault(require("lodash/times"));

var _slice = _interopRequireDefault(require("lodash/slice"));

var _BaseTableModel2 = _interopRequireDefault(require("./BaseTableModel"));

var _LoadingStates = _interopRequireDefault(require("./LoadingStates"));

var _size = _interopRequireDefault(require("lodash/size"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _reverse = _interopRequireDefault(require("lodash/reverse"));

var _map = _interopRequireDefault(require("lodash/map"));

var _orderBy = _interopRequireDefault(require("lodash/orderBy"));

var _mobx2 = require("../../../util/mobx");

var _class, _descriptor, _descriptor2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var StaticTableModel = (_class = /*#__PURE__*/function (_BaseTableModel) {
  _inherits(StaticTableModel, _BaseTableModel);

  var _super = _createSuper(StaticTableModel);

  function StaticTableModel(props) {
    var _this;

    _classCallCheck(this, StaticTableModel);

    _this = _super.call(this, props);

    _initializerDefineProperty(_assertThisInitialized(_this), "data", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "loadState", _descriptor2, _assertThisInitialized(_this));

    if (!(0, _isUndefined.default)(props.data)) {
      _this.data = (0, _mobx.observable)((0, _map.default)(props.data, function (row) {
        return _this.createRowModel(row);
      }));
      _this.loadState = _LoadingStates.default.DATA_LOADED;
    }

    return _this;
  }

  _createClass(StaticTableModel, [{
    key: "currentData",
    get: function get() {
      if (this.data.length === 0) {
        return [];
      }

      return this.pagedData[this.currentPage];
    }
  }, {
    key: "pagedData",
    get: function get() {
      var _this2 = this;

      var pagedData = {};
      var numberOfPages = Math.ceil(this.sortedData.length / this.itemsPerPage);
      (0, _times.default)(numberOfPages, function (pageNumber) {
        var pageStartIndex = pageNumber * _this2.itemsPerPage;
        var pageEndIndex = (pageNumber + 1) * _this2.itemsPerPage;
        pagedData[pageNumber] = (0, _slice.default)(_this2.sortedData, pageStartIndex, pageEndIndex);
      });
      return pagedData;
    }
  }, {
    key: "sortedData",
    get: function get() {
      var sortDefinitions = (0, _reverse.default)(this.sorts.slice());
      var columns = (0, _map.default)(sortDefinitions, function (sort) {
        return sort.iteratee;
      });
      var orders = (0, _map.default)(sortDefinitions, function (sort) {
        return sort.descending ? "desc" : "asc";
      });
      return (0, _orderBy.default)(this.filteredData, (0, _map.default)(columns, function (c) {
        return function (row) {
          return row.data.get(c);
        };
      }), orders);
    }
  }, {
    key: "filteredData",
    get: function get() {
      var filteredData = this.data;
      (0, _forEach.default)(_mobx2.observableMap.values(this.filters), function (filterDefinition) {
        filteredData = (0, _filter.default)(filteredData, function (rowModel) {
          return filterDefinition.func(rowModel.data);
        });
      });
      return filteredData;
    }
  }, {
    key: "recordCount",
    get: function get() {
      return this.filteredData.length;
    }
  }, {
    key: "pageCount",
    get: function get() {
      return (0, _size.default)(this.pagedData);
    }
  }, {
    key: "replaceData",
    value: function replaceData(data) {
      var _this3 = this;

      if (!(0, _isUndefined.default)(data)) {
        this.data = (0, _mobx.observable)((0, _map.default)(data, function (row) {
          return _this3.createRowModel(row);
        }));
      }
    }
  }, {
    key: "pushRowData",
    value: function pushRowData(rowData) {
      this.data.push(this.createRowModel(rowData));
    }
  }]);

  return StaticTableModel;
}(_BaseTableModel2.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.observable)([]);
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "loadState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _LoadingStates.default.UI_READY;
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pagedData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pagedData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortedData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortedData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recordCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "recordCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pageCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "replaceData", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "replaceData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pushRowData", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "pushRowData"), _class.prototype)), _class);
var _default = StaticTableModel;
exports.default = _default;